module.exports = __webpack_public_path__ + "img/join_bg.05120ce5.png";